import { Link } from "@tanstack/react-router";
import { Lock } from "lucide-react";

import { MapPreviewImage } from "#/components/MapPreviewImage";
import { Button } from "#/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "#/components/ui/card";
import { MAP_ACCESS_UPSELL_COPY, type MapAccessUpsellReason } from "#/lib/mapAccessUpsellCopy";
import { cn } from "#/lib/utils";
import { HERO_PREVIEW_BOX_PX } from "#/routes/-play.previewSizing";

export function PlayMapAccessGate({
  reason,
  mapId,
}: {
  reason: MapAccessUpsellReason;
  mapId: string;
}) {
  const copy = MAP_ACCESS_UPSELL_COPY[reason];

  return (
    <main className="mx-auto w-full max-w-[1080px] px-4 py-10">
      <div className="flex justify-center">
        <Card className="w-full max-w-sm">
          <CardHeader>
            <CardTitle>{copy.title}</CardTitle>
            <CardDescription>{copy.description}</CardDescription>
          </CardHeader>
          <CardContent>
            <PlayMapAccessPreview mapId={mapId} />
          </CardContent>
          <CardFooter>
            <Link to="/premium" preload={false} className="w-full">
              <Button size="lg" variant="premium" className="w-full">
                <Lock className="mr-2 size-4" aria-hidden />
                Upgrade
              </Button>
            </Link>
          </CardFooter>
        </Card>
      </div>
    </main>
  );
}

function PlayMapAccessPreview({ mapId }: { mapId: string }) {
  return (
    <MapPreviewImage
      mapId={mapId}
      maxSize={HERO_PREVIEW_BOX_PX}
      fillWidth
      className={cn(
        "group overflow-hidden rounded-xl border shadow-lg transition-opacity duration-150 ease-out group-hover:opacity-100",
      )}
    >
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center rounded-xl bg-foreground/25 backdrop-blur-xs transition-opacity duration-150 ease-out group-hover:opacity-0">
        <Lock className="text-background" size={32} strokeWidth={2} />
      </div>
    </MapPreviewImage>
  );
}
